export default "__VITE_ASSET__017de475__"